<template>
	<div class="MAM_queryList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
		<el-card class="box-card header" shadow="hover">
			<div class="headerDiv">
				<div class="headerMoney">{{formData.inventory_price}}</div>
				<div style="margin:5px 0px;">成本总计 (元)</div>
				<div>含：兑换终端</div>
			</div>
			<div class="headerDiv">
				<div class="headerMoney">{{formData.recovery_money}}</div>
				<div style="margin:5px 0px;">回本金额 (元)</div>
				<div>含：兑换终端</div>
			</div>
			<div class="headerDiv">
				<div class="headerMoney">{{formData.reward_money}}</div>
				<div style="margin:5px 0px;">奖励账户余额 (元)</div>
			</div>
		</el-card>

		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div class="conTitle">利润统计入库</div>
			<div class="mkDiv" @click="tiaozhuan(1)">
				<div class="mkTop">
					<span class="mkMoney">{{formData.inventory_price}}</span>
					<span>查看明细</span>
				</div>
				<div class="mkText">
					终端成本(元)
				</div>
			</div>
			<div class="mkDiv"  @click="tiaozhuan(2)">
				<div class="mkTop">
					<span class="mkMoney">{{formData.profit_total_money}}</span>
					<span>查看明细</span>
				</div>
				<div class="mkText">
					分润差额(元)
				</div>
			</div>
			<div class="mkDiv" @click="tiaozhuan(3)">
				<div class="mkTop">
					<span class="mkMoney">{{formData.flow_total_money}}</span>
					<span>查看明细</span>
				</div>
				<div class="mkText">
					流量卡分成(元)
				</div>
			</div>

			<!-- <div style="clear:both;"></div> -->

			<div class="mkDiv" @click="tiaozhuan(4)">
				<div class="mkTop">
					<span class="mkMoney">{{formData.profit_draw_total_money}}</span>
					<span>查看明细</span>
				</div>
				<div class="mkText">
					分润账户提现税点(元)
				</div>
			</div>
			<div class="mkDiv" @click="tiaozhuan(5)">
				<div class="mkTop">
					<span class="mkMoney">{{formData.activity_draw_total_money}}</span>
					<span>查看明细</span>
				</div>
				<div class="mkText">
					达标返现账户提现税点(元)
				</div>
			</div>
			<div class="mkDiv" @click="tiaozhuan(6)">
				<div class="mkTop">
					<span class="mkMoney">{{formData.deposit_draw_total_money}}</span>
					<span>查看明细</span>
				</div>
				<div class="mkText">
					押金账户提现税点(元)
				</div>
			</div>
			<div class="mkDiv" @click="tiaozhuan(7)">
				<div class="mkTop">
					<span class="mkMoney">{{formData.reward_draw_total_money}}</span>
					<span>查看明细</span>
				</div>
				<div class="mkText">
					奖励账户提现税点(元)
				</div>
			</div>
			<div class="mkDiv" @click="tiaozhuan(8)">
				<div class="mkTop">
					<span class="mkMoney">{{formData.special_reward_draw_total_money}}</span>
					<span>查看明细</span>
				</div>
				<div class="mkText">
					特惠奖励账户提现税点(元)
				</div>
			</div>
            <div class="mkDiv" @click="tiaozhuan(9)">
            	<div class="mkTop">
            		<span class="mkMoney">{{formData.dividend_reward_draw_total_money}}</span>
            		<span>查看明细</span>
            	</div>
            	<div class="mkText">
            		大盘分红账户提现税点(元)
            	</div>
            </div>
            <div class="mkDiv" @click="tiaozhuan(10)">
            	<div class="mkTop">
            		<span class="mkMoney">{{formData.manage_reward_draw_total_money}}</span>
            		<span>查看明细</span>
            	</div>
            	<div class="mkText">
            		管理奖账户提现税点(元)
            	</div>
            </div>
            <div class="mkDiv" @click="tiaozhuan(11)">
            	<div class="mkTop">
            		<span class="mkMoney">{{formData.salary_reward_draw_total_money}}</span>
            		<span>查看明细</span>
            	</div>
            	<div class="mkText">
            		底薪奖账户提现税点(元)
            	</div>
            </div>
            <div class="mkDiv" @click="tiaozhuan(12)">
            	<div class="mkTop">
            		<span class="mkMoney">{{formData.flow_reward_draw_total_money}}</span>
            		<span>查看明细</span>
            	</div>
            	<div class="mkText">
            		流量卡账户提现税点(元)
            	</div>
            </div>
		</el-card>

	</div>
</template>

<script>
	export default {
		name: "costing",
		data() {
			return {
				user_id: this.$route.query.user_id,
				formData: {
					inventory_price: "0.00",
					recovery_money: "0.00",
					reward_money: "0.00",
					profit_total_money: "0.00",
					flow_total_money: "0.00",
					profit_draw_total_money: "0.00",
					activity_draw_total_money: "0.00",
					deposit_draw_total_money: "0.00",
					reward_draw_total_money: "0.00",
					special_reward_draw_total_money: "0.00"
				},
			}
		},
		mounted() {
			this.getData()
		},
		methods: {

			getData() {
				this.$api.post("userteamleader/userTeamCosting", {
					user_id: this.$route.query.user_id
				}, res => {
					if (res.code == 0) {
						this.formData = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			//跳转
			tiaozhuan(index){
				if(index == 1){
					this.$router.push({path: '/terminalPickup',query: {user_id: this.user_id}});
					return false;
				}
				if(index == 2){
					this.$router.push({path: '/differenceShareProfit',query: {user_id: this.user_id}});
					return false;
				}
				if(index == 3){
					this.$router.push({path: '/trafficCardSharing',query: {user_id: this.user_id}});
					return false;
				}
				if(index == 4){
					this.$router.push({path: '/profitWithdrawalPoint',query: {user_id: this.user_id}});
					return false;
				}
				if(index == 5){
					this.$router.push({path: '/activityWithdrawalPoint',query: {user_id: this.user_id}});
					return false;
				}
				if(index == 6){
					this.$router.push({path: '/depositWithdrawalPoint',query: {user_id: this.user_id}});
					return false;
				}
				if(index == 7){
					this.$router.push({path: '/rewardAccountShaiDian',query: {user_id: this.user_id}});
					return false;
				}
				if(index == 8){
					this.$router.push({path: '/specialRewardDetail',query: {user_id: this.user_id}});
					return false;
				}
                if(index == 9){
                	this.$router.push({path: '/bigAwardDetail',query: {user_id: this.user_id}});
                	return false;
                }
                if(index == 10){
                	this.$router.push({path: '/mangerAwardDetail',query: {user_id: this.user_id}});
                	return false;
                }
                if(index == 11){
                	this.$router.push({path: '/downSalaryReward',query: {user_id: this.user_id}});
                	return false;
                }
                if(index == 12){
                	this.$router.push({path: '/flowCardCostDetail',query: {user_id: this.user_id}});
                	return false;
                }
                
                
                
                
			}
		}
	};
</script>

<style scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}

	.header>.el-card__body {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.headerDiv {
		padding: 0px 40px;
		font-size: 14px;
		color: #E6A23C;
	}

	.headerMoney {
		font-size: 28px;
		font-weight: bold;
	}

	.conTitle {
		font-size: 22px;
		font-weight: bold;
		color: #409EFF;
	}

	.mkDiv {
		width: 200px;
		height: 90px;
		border: 1px solid #409EFF;
		float: left;
		margin-right: 50px;
		margin-top: 20px;
		margin-bottom: 10px;
		color: #409EFF;
		font-size: 14px;
		border-radius: 3px;
	}

	.mkMoney {
		font-size: 18px;
		font-weight: bold;
	}

	.mkTop {
		height: 60px;
		line-height: 50px;
		margin: 0px 15px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	.mkText {
		height: 30px;
		margin: 0px 15px;
	}
</style>